import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import RequestTypes from "./Forms";
import Issuers from "./Issuers";
import Categories from "./Categories";
import { Tabs } from "components/common_components/Tabs";
import Header from "components/common_components/Header";

const options = [
    { index: 0, label: "Issuers", path: "/settings/forms/issuers", icon: "archive" },
    { index: 1, label: "Categories", path: "/settings/forms/categories", icon: "file-doc" },
    { index: 2, label: "Forms", path: "/settings/forms/forms", icon: "file-doc" },
];

function Forms(props) {
    const history = useHistory();
    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    function handleChange(_, newIndex) {
        history.push(options.find((o) => o.index === newIndex).path);
    }

    const renderTabLabel = (label) => {
        return label;
    };
    return (
        <>
            <Header title="Forms" />
            <Tabs options={options} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel}>
                <Switch>
                    <Redirect exact from="/settings/forms" to="/settings/forms/forms" />
                    <Route exact path="/settings/forms/issuers" component={Issuers} />
                    <Route exact path="/settings/forms/categories" component={Categories} />
                    <Route exact path="/settings/forms/forms" component={RequestTypes} />
                </Switch>
            </Tabs>
        </>
    );
}

export default Forms;
